import React, { useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { DownOutlined, ScanOutlined, ClearOutlined } from '@ant-design/icons';
import {
  Col,
  Row,
  Tabs,
  Button,
  Modal,
  Select,
  Tooltip,
  Dropdown,
  Menu,
  Space,
  Spin,
  message,
  Typography
} from 'antd';
//Components
import Wait4Me from '../../../components/Wait4Me';
import BreadCrumb from '../../../components/BreadCrumb';
import NoDataToDisplay from '../../../components/NoDataToDisplay';
import NSAlertDetailHits from './component/NSAlertDetailHits';
import NSAlertDetailTopPannel from './component/NSAlertDetailTopPannel';
import NSAlertDetailPartyIdentity from './component/NSAlertDetailPartyIdentity';
import { ROUTE_AMLS_SMART_SCREENING } from '../../../pages/constants/globalConstants';
import {
  ALERT_SOURCEID_MAPPING,
  GLOBAL_SETTINGS_SOURCE_MAPPING,
  DDMMYYYYHHMMTimeFormatForFileDownload
} from '../../../util/GlobalConstant';

import style from './index.scss';
import styled from 'styled-components';
import { cloneDeep, get, set, union } from 'lodash';
import { StyledAlertDetailsFilters } from '../onDemandScreening/styled';
import AttributeSearch from '../../cm/common/AttributeSearch';
import SortComponent from '../../cm/common/SortModal';
import FilterDropdown from './component/FilterDropDown';

const { Option } = Select;
const { confirm } = Modal;
const { Text } = Typography;

export const AlertDetail = ({
  apiActions,
  settings,
  runInstance,
  match,
  alertId,
  isEmbedded = false,
  alertMetaSuffix,
  alertMetaPrefix,
  authentication,
  nsInvestigation,
  isFromNameScreening,
  amlsCommon
}) => {
  const [entityIndex, setEntityIndex] = useState(0);
  const [currentSource, setCurrentSource] = useState(null);
  const [selectedForCompare, setSelectedForCompare] = useState([]);
  const [totalDiff, setTotalDiff] = useState([]);
  const [isCompared, setIsCompared] = useState(false);
  const [whiteListedSelect, setWhiteListedSelect] = useState([]);
  const [alertDetails, setAlertDetails] = useState({});
  const [filteredAlertDetails, setFilteredAlertDetails] = useState(null);
  const [filters, setFilters] = useState({
    hitLevel: undefined,
    nameOfWatchlist: undefined,
    watchlistCategory: undefined,
    watchlistSubCategory: undefined,
    watchlistKeyword: undefined,
    watchlistSource: undefined,
    hitScore: null,
    nameScore: null,
    aliasScore: null,
    addressScore: null,
    dobScore: null,
    cobScore: null,
    nationalityScore: null,
    genderScore: null,
    searchField: '',
    searchText: null,
    sortBy: null,
    sortByOrder: null
  });
  const [filterData, setFilterData] = useState({
    nameOfWatchlist: [],
    watchlistCategory: [],
    watchlistSubCategory: [],
    watchlistKeyword: [],
    watchlistSource: []
  });

  const searchOptions = [
    {
      label: 'Watchlist Name',
      value: 'nameOfWatchlist'
    }
  ];

  const widgetItemOperations = [
    {
      itemName: 'Hit Score',
      key: 'hitScore',
      dataType: 'NUMBER',
      isSortable: true
    },
    {
      itemName: 'Name Score',
      key: 'nameNameMatchScore',
      dataType: 'NUMBER',
      isSortable: true
    },
    {
      itemName: 'Alias Score',
      key: 'nameAliasMatchScore',
      dataType: 'NUMBER',
      isSortable: true
    },
    {
      itemName: 'Address Score',
      key: 'addressMatchScore',
      dataType: 'NUMBER',
      isSortable: true
    },
    {
      itemName: 'DOB Score',
      key: 'dobMatchScore',
      dataType: 'NUMBER',
      isSortable: true
    },
    {
      itemName: 'Country of birth Score',
      key: 'birthCountryMatchScore',
      dataType: 'NUMBER',
      isSortable: true
    },
    {
      itemName: 'Nationality Score',
      key: 'nationalityMatchScore',
      dataType: 'NUMBER',
      isSortable: true
    },
    {
      itemName: 'Gender Score',
      key: 'genderMatchScore',
      dataType: 'NUMBER',
      isSortable: true
    }
  ];

  const {
    navigateTo,
    getNSGlobalSettingsPageInfo,
    getNSAlertDetailsListData,
    sendToCMAlerts,
    downloadSelectedAlerts,
    getAMLSCommonAlertDetails,
    getAMLSCommonAlertPartyIdentity,
    fetchAMLSAlertLevel
  } = apiActions;

  const {
    alertDetails: commomAlertDetails,
    alertPartyIdentity,
    alertLevelConfigs
  } = amlsCommon;
  const { sendToCM: sendToCMDetails } = nsInvestigation;
  const { data: alertLevels } = alertLevelConfigs;

  const { alertDetails: runInstanceAlerts, hitsUserFeedback } = runInstance;
  const { TabPane } = Tabs;

  useEffect(() => {
    const filteredEntitiesWithHits = runInstanceAlerts?.entities
      ?.filter((entity) => entity.hits && entity.hits.length)
      ?.map((entity) => ({
        ...entity,
        ...(entity.individualCorporateType?.toLowerCase() === 'c' &&
          !Object.prototype.hasOwnProperty.call(entity, 'partyIdNo') && {
            partyIdNo: entity.registeredNumber
          }),
        hits: entity.hits.sort((a, b) => b.hitScore - a.hitScore)
      }));
    const alertDetailsWithHits = {
      ...runInstanceAlerts,
      entities: cloneDeep(filteredEntitiesWithHits)
    };
    setAlertDetails(cloneDeep(alertDetailsWithHits));
    setFilteredAlertDetails(cloneDeep(alertDetailsWithHits));
  }, [runInstanceAlerts]);

  useEffect(() => {
    const uniqueNonEmpty = (value, index, self) =>
      value && self.indexOf(value) === index;

    const allAlerts =
      get(cloneDeep(filteredAlertDetails), `entities.${entityIndex}`)?.hits ||
      [];
    const getUniqueValues = (key) =>
      allAlerts.map((a) => a[key]?.toLowerCase()).filter(uniqueNonEmpty) || [];

    setFilterData({
      nameOfWatchlist: getUniqueValues('nameOfWatchlist'),
      watchlistCategory: getUniqueValues('watchlistCategory'),
      watchlistSubCategory: getUniqueValues('watchlistSubCategory'),
      watchlistKeyword: getUniqueValues('keywords'),
      watchlistSource: getUniqueValues('watchlistSource')
    });
  }, [filteredAlertDetails, entityIndex]);

  useEffect(() => {
    const allAlerts =
      get(cloneDeep(filteredAlertDetails), `entities.${entityIndex}`)?.hits ||
      [];

    const filteredData = filterAlertData(allAlerts);
    const filteredAlerts = cloneDeep(filteredAlertDetails);
    set(filteredAlerts, `entities[${entityIndex}].hits`, filteredData);
    setFilteredAlertDetails({ ...filteredAlerts });
  }, [filters]);

  const filterAlertData = (data) => {
    if (
      !filters.watchlistCategory &&
      !filters.watchlistSubCategory &&
      !filters.nameOfWatchlist &&
      !filters.watchlistKeyword &&
      !filters.watchlistSource &&
      !filters.hitLevel &&
      !filters.hitScore &&
      !filters.nameScore &&
      !filters.aliasScore &&
      !filters.addressScore &&
      !filters.dobScore &&
      !filters.cobScore &&
      !filters.nationalityScore &&
      !filters.genderScore &&
      !filters.searchField &&
      !filters.searchText &&
      !filters.sortBy &&
      !filters.sortByOrder
    ) {
      return data;
    } else {
      return data
        .filter(
          (item) =>
            (!filters.watchlistCategory ||
              item.watchlistCategory?.toLowerCase() ===
                filters.watchlistCategory?.toLowerCase()) &&
            (!filters.watchlistSubCategory ||
              item.watchlistSubCategory?.toLowerCase() ===
                filters.watchlistSubCategory?.toLowerCase()) &&
            (!filters.nameOfWatchlist ||
              item.nameOfWatchlist?.toLowerCase() ===
                filters.nameOfWatchlist?.toLowerCase()) &&
            (!filters.hitLevel || item.hitLevel === filters.hitLevel) &&
            (!filters.watchlistKeyword ||
              item.keywords?.toLowerCase() ===
                filters.watchlistKeyword?.toLowerCase()) &&
            (!filters.watchlistSource ||
              item.watchlistSource?.toLowerCase() ===
                filters.watchlistSource?.toLowerCase()) &&
            (!filters.hitScore || item.hitScore >= filters.hitScore) &&
            (!filters.nameScore ||
              item.nameNameMatchScore >= filters.nameScore) &&
            (!filters.aliasScore ||
              item.nameAliasMatchScore >= filters.aliasScore) &&
            (!filters.addressScore ||
              item.addressMatchScore >= filters.addressScore) &&
            (!filters.dobScore || item.dobMatchScore >= filters.dobScore) &&
            (!filters.cobScore ||
              item.birthCountryMatchScore >= filters.cobScore) &&
            (!filters.nationalityScore ||
              item.nationalityMatchScore >= filters.nationalityScore) &&
            (!filters.genderScore ||
              item.genderMatchScore >= filters.genderScore) &&
            (!filters.searchField ||
              item[filters.searchField]
                ?.toLocaleLowerCase()
                .includes(filters.searchText.toLocaleLowerCase()))
        )
        .sort((a, b) => {
          if (!filters.sortBy) {
            return 0;
          }

          if (
            typeof a[filters.sortBy] === 'string' &&
            typeof b[filters.sortBy] === 'string'
          ) {
            return filters.sortByOrder === 'ASC'
              ? a[filters.sortBy].localeCompare(b[filters.sortBy])
              : b[filters.sortBy].localeCompare(a[filters.sortBy]);
          } else {
            return filters.sortByOrder === 'ASC'
              ? a[filters.sortBy] - b[filters.sortBy]
              : b[filters.sortBy] - a[filters.sortBy];
          }
        });
    }
  };

  useEffect(() => {
    //This is to check if filtered options available when isWhitelisted selection does not exist.
    const filtersApplied = Object.values(filters).filter(
      (value) => value !== undefined && value !== null
    );
    if (
      alertDetails?.entities?.length > 0 &&
      (filtersApplied.length || whiteListedSelect.length)
    ) {
      const allAlerts = get(
        cloneDeep(alertDetails),
        `entities.${entityIndex}.hits`,
        []
      );
      const filteredItems = whiteListedSelect.length
        ? allAlerts.filter((hit) =>
            whiteListedSelect.includes(hit?.isWhitelisted?.toString())
          )
        : allAlerts;
      const finalFilteredItems = filterAlertData(filteredItems);
      const filteredAlerts = cloneDeep(alertDetails);
      set(filteredAlerts, `entities[${entityIndex}].hits`, finalFilteredItems);
      setFilteredAlertDetails({ ...filteredAlerts });
    } else {
      setFilteredAlertDetails(cloneDeep(alertDetails));
    }
  }, [whiteListedSelect, filters]);

  useEffect(() => {
    getAMLSCommonAlertDetails({ alertId: alertId || match.params.id });
    getNSAlertDetailsListData({ id: alertId || match.params.id });
    resetHitsToCompare();

    if (!alertLevels?.length) {
      fetchAMLSAlertLevel();
    }
  }, [alertId]);

  useEffect(() => {
    if (alertDetails) {
      const { alertSourceId } = alertDetails || {};
      const source = ALERT_SOURCEID_MAPPING[alertSourceId];
      setCurrentSource(source);
      if (alertSourceId) {
        getAMLSCommonAlertPartyIdentity({
          alertId: alertId || match?.params?.id,
          isList: true
        });
      }
    }
  }, [alertDetails]);

  useEffect(() => {
    if (currentSource) {
      getNSGlobalSettingsPageInfo({
        pageId: GLOBAL_SETTINGS_SOURCE_MAPPING[currentSource].pageId
      });
    }
  }, [currentSource]);

  const getGSConfig = (q) => {
    if (settings?.nsSetting?.data?.uiWidgetGroups) {
      const groups = settings.nsSetting.data.uiWidgetGroups;
      return groups
        .find((g) => g.widgetGroupId === q.widgetGroupId)
        ?.widgets.find((w) => w.widgetId === q.widgetId);
    }
    return {};
  };

  const topPanelWidgetId =
    GLOBAL_SETTINGS_SOURCE_MAPPING?.[currentSource]?.['topPanelWidgetId'];
  const topPanelWidgetGoupId =
    GLOBAL_SETTINGS_SOURCE_MAPPING?.[currentSource]?.['topPanelWidgetGoupId'];
  const identityWidgetId =
    GLOBAL_SETTINGS_SOURCE_MAPPING?.[currentSource]?.['identityWidgetId'];
  const identityAndhitsExplainabilityWidgetGroupId =
    GLOBAL_SETTINGS_SOURCE_MAPPING?.[currentSource]?.[
      'identityAndhitsExplainabilityWidgetGroupId'
    ];
  const hitsExplainabilityWidgetId =
    GLOBAL_SETTINGS_SOURCE_MAPPING?.[currentSource]?.[
      'hitsExplainabilityWidgetId'
    ];

  const tabChangeHandler = (tab) => {
    setEntityIndex(tab);
    setFilters({
      hitLevel: undefined,
      nameOfWatchlist: undefined,
      watchlistCategory: undefined,
      watchlistSubCategory: undefined,
      watchlistKeyword: undefined,
      watchlistSource: undefined,
      hitScore: null,
      nameScore: null,
      aliasScore: null,
      addressScore: null,
      dobScore: null,
      cobScore: null,
      nationalityScore: null,
      genderScore: null
    });
    //reset hits selection on entity change
    resetHitsToCompare();
  };

  const resetFilter = () => {
    setFilters({
      hitLevel: undefined,
      nameOfWatchlist: undefined,
      watchlistCategory: undefined,
      watchlistSubCategory: undefined,
      watchlistKeyword: undefined,
      watchlistSource: undefined,
      hitScore: null,
      nameScore: null,
      aliasScore: null,
      addressScore: null,
      dobScore: null,
      cobScore: null,
      nationalityScore: null,
      genderScore: null
    });
  };

  const generateExplainabilityHandler = () => {
    warning();
  };

  function warning() {
    Modal.warning({
      title: 'Score explainability not available!',
      content: (
        <p>
          Score explainability is not available at the moment. Please try after
          30 mins.
        </p>
      ),
      className: 'warningModal',
      onOk() {
        setTimeout(() => {
          setGeneratePipelineClicked(true);
        }, 2000);
      },
      okText: 'Close'
    });
  }

  const resetHitsToCompare = () => {
    setTotalDiff([]);
    setIsCompared(false);
    setSelectedForCompare([]);
  };

  const compareTwoHits = () => {
    if (isCompared) {
      //Once compared reset
      resetHitsToCompare();
    } else {
      const allAlerts = get(alertDetails, `entities.${entityIndex}`).hits || [];
      const filteredItems = allAlerts.filter((a) =>
        selectedForCompare.some((s) => s === a.hitId)
      );

      const allObjKeys = union([
        ...Object.keys(filteredItems[0]),
        ...Object.keys(filteredItems[1])
      ]);

      const diffInFields = allObjKeys.filter((field) => {
        if (field === 'hitId') {
          return false;
        }
        let obj1Value = filteredItems[0][field];
        let obj2Value = filteredItems[1][field];

        if (field === 'partyIdNo' || field === 'registeredNumber') {
          obj1Value = filteredItems[0]['watchlistIdentificationNumber'];
          obj2Value = filteredItems[1]['watchlistIdentificationNumber'];
        }
        if (obj1Value === undefined || obj2Value === undefined) {
          return true;
        }
        if (typeof obj2Value === 'string') {
          return obj2Value.toLowerCase() !== obj1Value.toLowerCase();
        }
        return obj2Value !== obj1Value;
      });

      if (diffInFields.includes('watchlistIdentificationNumber')) {
        diffInFields.push('partyIdNo', 'registeredNumber');
      }

      setTotalDiff(diffInFields);
      setIsCompared(true);
    }
  };

  const sendToCM = () => {
    confirm({
      title: `Send to CM`,
      content: `Are you sure you want to generate an alert in CM?`,
      centered: true,
      okText: 'Confirm',
      width: 500,
      okButtonProps: {
        style: {
          backgroundColor: '#2B73E0'
        }
      },
      onOk: () => {
        sendToCMAlerts({
          ids: [alertId || match.params.id],
          isFromAlertList: false
        });
      }
    });
  };

  const downloadAlerts = () => {
    downloadSelectedAlerts({
      ids: [alertId || match.params.id],
      fileName: `Alert_Details_Page__${moment().format(
        DDMMYYYYHHMMTimeFormatForFileDownload
      )}.csv`
    });
  };

  const takeActionMenu = (
    <Menu onClick={() => {}} disabled={!alertDetails?.alertId}>
      <Menu.Item key="1" onClick={() => downloadAlerts()}>
        Download alert
      </Menu.Item>
      {isFromNameScreening && (
        <Menu.Item
          key="2"
          disabled={commomAlertDetails?.data?.isSentToCm}
          onClick={() => sendToCM()}>
          Send to CM
        </Menu.Item>
      )}
    </Menu>
  );

  const onSelectForComparision = (hitId) => {
    if (selectedForCompare.includes(hitId)) {
      setSelectedForCompare([...selectedForCompare.filter((f) => f !== hitId)]);
      setTotalDiff([]);
      setIsCompared(false);
    } else if (selectedForCompare.length === 2) {
      return message.error('Only 2 hits can be added to compare');
    } else {
      setSelectedForCompare([...selectedForCompare, hitId]);
    }
  };

  const onFilterChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value
    }));
  };

  const isWhitelistedGlobally = get(
    alertDetails,
    `entities.${entityIndex}.isWhitelisted`
  );

  const whitelistDisableHoverText =
    'Filter disabled, as Entity is globally whitelisted';

  const alertPartyIdentityData = useMemo(() => {
    if (
      commomAlertDetails?.data?.primaryPartyKey &&
      alertPartyIdentity?.data?.length
    ) {
      return alertPartyIdentity?.data?.find(
        (item) => item.partyKey === commomAlertDetails.data.primaryPartyKey
      );
    }
  }, [commomAlertDetails, alertPartyIdentity]);

  const individualCorporateType = (entityPartyKey) =>
    alertPartyIdentity?.data?.find((item) => item.partyKey === entityPartyKey)
      ?.individualCorporateType ||
    commomAlertDetails?.data?.individualCorporateType;

  return (
    <Spin spinning={sendToCMDetails.isLoading}>
      <Row>
        <Col span={24}>
          <div className={style.wrapper}>
            {settings?.nsSetting?.isLoading || runInstance?.isLoading ? (
              <div className={style.loadingWrapper}>
                <Wait4Me />
              </div>
            ) : (
              <React.Fragment>
                <div>
                  <div className={style.head}>
                    {isEmbedded !== true && (
                      <BreadCrumb
                        crumbs={[
                          {
                            label: 'Run Instance',
                            linkTo: `${ROUTE_AMLS_SMART_SCREENING}/runInstance?tab=2`
                          },
                          { label: 'Alert View' }
                        ]}
                      />
                    )}
                    {alertDetails.error === undefined ? (
                      <NSAlertDetailTopPannel
                        isEmbedded={isEmbedded}
                        GS={getGSConfig({
                          widgetGroupId: topPanelWidgetGoupId,
                          widgetId: topPanelWidgetId
                        })}
                        navigateTo={navigateTo}
                        data={alertDetails}
                        alertMetaPrefix={alertMetaPrefix}
                        alertMetaSuffix={alertMetaSuffix}
                      />
                    ) : (
                      <div className={style.noDataToDisplayWrapper}>
                        <NoDataToDisplay />
                      </div>
                    )}
                  </div>
                </div>
                <div>
                  {alertDetails?.entities?.length ? (
                    <div className={style.alertDetailTabs}>
                      <Tabs
                        defaultActiveKey={entityIndex}
                        onChange={tabChangeHandler}>
                        {alertDetails?.entities?.map((entity, index) => (
                          <TabPane
                            tab={`Entity ${index + 1}`}
                            key={index}></TabPane>
                        ))}
                      </Tabs>
                    </div>
                  ) : null}
                </div>
                {alertDetails.error === undefined ? (
                  <div className={style.alertDetailBody}>
                    <div className={style.alertHeader}>
                      <h4>Entity Identity and Score Explainability</h4>
                      <div className="filters">
                        <FilterDropdown
                          placement="bottomRight"
                          filterButtonStyle={{
                            'align-items': 'flex-start',
                            height: '32px'
                          }}
                          className={`filters-icon`}>
                          <StyledAlertDetailsFilters
                            filters={filters}
                            filterData={filterData}
                            onChange={onFilterChange}
                            resetFilter={resetFilter}
                            alertLevels={alertLevels}
                          />
                        </FilterDropdown>
                        <StyledSortContainer>
                          <SortComponent
                            iconStyle={{ height: '32px' }}
                            widgetItemOperations={widgetItemOperations}
                            selectedValue={{
                              columnName: filters.sortBy,
                              operator: filters.sortByOrder
                            }}
                            applySortingHandler={(sort) =>
                              setFilters({
                                ...filters,
                                sortBy: sort?.columnName,
                                sortByOrder: sort?.operator
                              })
                            }
                          />
                        </StyledSortContainer>
                        <StyledSearchContainer>
                          <AttributeSearch
                            size="middle"
                            searchField={filters.searchField}
                            searchText={filters.searchText}
                            options={searchOptions}
                            onSearch={(searchField, searchText) =>
                              setFilters((prev) => ({
                                ...prev,
                                searchField:
                                  searchField === 'Search by'
                                    ? ''
                                    : searchField,
                                searchText:
                                  searchField === 'Search by' ? '' : searchText
                              }))
                            }
                          />
                        </StyledSearchContainer>
                        <div className="select-filters">
                          <Text style={{ color: '#748aa1' }}>
                            Is Whitelisted
                          </Text>
                          <Tooltip
                            title={
                              isWhitelistedGlobally
                                ? whitelistDisableHoverText
                                : ''
                            }>
                            <Select
                              mode="multiple"
                              allowClear
                              showSearch={false}
                              placeholder={`Please Select`}
                              onChange={(e) => setWhiteListedSelect(e)}
                              value={whiteListedSelect}
                              disabled={isWhitelistedGlobally}
                              style={{ minWidth: '175px', maxWidth: '325px' }}>
                              <Option value="true">True</Option>
                              <Option value="false">False</Option>
                            </Select>
                          </Tooltip>
                        </div>
                        <Tooltip
                          title={
                            selectedForCompare.length < 2
                              ? 'Select 2 hits to compare'
                              : `${
                                  !isCompared
                                    ? 'Click to compare'
                                    : 'Click to reset'
                                }`
                          }>
                          <Button
                            onClick={compareTwoHits}
                            disabled={selectedForCompare.length < 2}
                            icon={
                              isCompared ? <ClearOutlined /> : <ScanOutlined />
                            }>
                            {isCompared ? `Reset` : `Compare`}
                          </Button>
                        </Tooltip>
                        <Dropdown overlay={takeActionMenu}>
                          <Button type="primary" className={style.actionButton}>
                            <Space>
                              Take Action
                              <DownOutlined />
                            </Space>
                          </Button>
                        </Dropdown>
                      </div>
                    </div>
                    {filteredAlertDetails?.entities?.length && (
                      <div>
                        <NSAlertDetailPartyIdentity
                          GS={getGSConfig({
                            widgetGroupId:
                              identityAndhitsExplainabilityWidgetGroupId,
                            widgetId: identityWidgetId
                          })}
                          alertPartyIdentity={alertPartyIdentityData || {}}
                          data={get(
                            filteredAlertDetails,
                            `entities.${entityIndex}`
                          )}
                        />
                        {get(
                          filteredAlertDetails,
                          `entities.${entityIndex}.hits`
                        ) && (
                          <div style={{ marginTop: '32px' }}>
                            <NSAlertDetailHits
                              GS={getGSConfig({
                                widgetGroupId:
                                  identityAndhitsExplainabilityWidgetGroupId,
                                widgetId: hitsExplainabilityWidgetId
                              })}
                              totalDiff={totalDiff}
                              data={get(
                                filteredAlertDetails,
                                `entities.${entityIndex}`
                              )}
                              apiActions={apiActions}
                              authentication={authentication}
                              selectedForCompare={selectedForCompare}
                              onSelectForComparision={onSelectForComparision}
                              hitsUserFeedback={hitsUserFeedback}
                              alertLevels={alertLevels}
                              individualCorporateType={individualCorporateType(
                                get(
                                  filteredAlertDetails,
                                  `entities.${entityIndex}.partyId`
                                )
                              )}
                            />
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ) : (
                  <div className={style.noDataToDisplayWrapper}>
                    <NoDataToDisplay />
                  </div>
                )}
              </React.Fragment>
            )}
          </div>
        </Col>
      </Row>
    </Spin>
  );
};

const StyledSearchContainer = styled.div`
  margin-left: auto;
`;

const StyledSortContainer = styled.div`
  height: inherit;
`;

AlertDetail.propTypes = {
  apiActions: PropTypes.shape({
    navigateTo: PropTypes.func.isRequired,
    getNSGlobalSettingsPageInfo: PropTypes.func.isRequired,
    getAMLSCommonAlertPartyIdentity: PropTypes.func.isRequired,
    fetchAMLSAlertLevel: PropTypes.func.isRequired
  }).isRequired,
  settings: PropTypes.object,
  isEmbedded: PropTypes.bool,
  alertMetaPrefix: PropTypes.element,
  alertMetaSuffix: PropTypes.element,
  alertId: PropTypes.string,
  runInstance: PropTypes.object,
  amlsCommon: PropTypes.object
};

export default AlertDetail;
